// src/pages/Warranty.jsx
import React from "react";

export default function Warranty() {
  return (
    <section className="mx-auto max-w-5xl px-6 py-16 text-neutral-900">
      <h1 className="text-3xl font-bold mb-6">Lifetime Structural Warranty</h1>
      <p className="mb-4">
        Unlimited Levels forged wheels are backed by a **Lifetime Structural Warranty** 
        against manufacturing defects. This warranty applies only to the original 
        purchaser and covers any structural failure of the wheel caused by a defect 
        in materials or workmanship under normal and intended use.
      </p>
      <p className="mb-4">
        Cosmetic finishes (such as paint, polish, or powder coat) are covered for 
        **1 year** from the date of purchase against defects in materials or workmanship. 
        Damage caused by accidents, curb impacts, road hazards, misuse, improper 
        installation, or neglect is not covered.
      </p>
      <p className="mb-4">
        Unlimited Levels reserves the right to inspect any wheel claimed under warranty. 
        If a manufacturing defect is verified, the wheel will be repaired or replaced 
        at our discretion. Shipping and removal/installation costs are not included.
      </p>
      <p className="mt-8 italic">
        *This warranty does not cover damage caused by impact, racing, off-road use, 
        or modification. Warranty claims must be accompanied by proof of purchase.*
      </p>
    </section>
  );
}
